import { useMemo } from 'react';
import { useOutletContext } from 'react-router-dom';
import { ProductType } from '~/models/product/ProductType';
import { REMOTE_INSTALLATION_PRODUCT_KEY } from '~/store/campaign/byod.constants';
import { useBasket } from '../useBasket';
import { MappedCampaign } from '../v2.utils';
import { ProductGroupV2 } from '../components/ProductGroupV2';

export const SelectEquipmentProducts: React.FC = () => {
  const campaign = useOutletContext<MappedCampaign>();

  // Remote installation product only to be displayed for SMB3 and Streambox
  const hasOrderedReceiverSmb3OrStreambox = useBasket((s) =>
    s.selectedProducts.some((sp) => sp.productType === ProductType.Receiver && (sp.productKey === 'smb3' || sp.productKey === 'sb')),
  );
  const installationProducts = useMemo(() => {
    return hasOrderedReceiverSmb3OrStreambox
      ? campaign.products.installation
      : campaign.products.installation.map((bundle) => ({
          ...bundle,
          offers: bundle.offers.filter((offer) => offer.productKey !== REMOTE_INSTALLATION_PRODUCT_KEY),
        }));
  }, [hasOrderedReceiverSmb3OrStreambox, campaign.products.installation]);

  return (
    <>
      <ProductGroupV2 group={campaign.products.receiver} config={campaign.configs.receiver} type={ProductType.Receiver} />
      <ProductGroupV2 group={installationProducts} config={campaign.configs.installation} type={ProductType.Installation} />
      <ProductGroupV2 group={campaign.products.equipment} config={campaign.configs.equipment} type={ProductType.Equipment} />
    </>
  );
};
